import React from 'react';
import { IGoodReceive } from '@/interfaces/goodReceive';
import TemplateReceiveOrderHeader from './components/template-receive-order-header';
import TemplateReceiveOrderInfo from './components/template-receive-order-info';
import TemplateReceiveOrderInfoItem from './components/template-receive-info-item';
import TemplateReceiveOrderFooter from './components/template-receive-order-footer';

interface IProps {
  data?: IGoodReceive;
}

const TM22 = ({ data }: IProps) => {
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateReceiveOrderHeader />
      <TemplateReceiveOrderInfo data={data} />
      <TemplateReceiveOrderInfoItem data={data} />
      <TemplateReceiveOrderFooter />
    </div>
  );
};

export default TM22;
